import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FiWifiOff, FiWifi } from "react-icons/fi";
import "./OfflineBanner.css";

export default function OfflineBanner() {
  const { t } = useTranslation('systemState');
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [justReconnected, setJustReconnected] = useState(false);

  useEffect(() => {
    const handleOffline = () => {
      setIsOffline(true);
      setJustReconnected(false);
    };
    const handleOnline = () => {
      setIsOffline(false);
      setJustReconnected(true);
      setTimeout(() => setJustReconnected(false), 3000);
    };

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);
    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  useEffect(() => {
    document.body.classList.toggle("is-offline", isOffline || justReconnected);
  }, [isOffline, justReconnected]);

  if (!isOffline && !justReconnected) return null;

  return isOffline ? (
    <div className="offline-banner offline-banner--offline">
      <FiWifiOff size={14} />
      {t('offline')}
    </div>
  ) : (
    <div className="offline-banner offline-banner--online">
      <FiWifi size={14} />
      {t('reconnected')}
    </div>
  );
}
